const TEXT_CONSTANTS = Object.freeze({
  BUTTON: {
    TRY_IT_FREE: "Try It Free for 7 Days",
    VERIFY_OTP: "Verify OTP and Register",
  },
  CHECKBOX: {
    I_AGREE: "I agree to the Terms of Service and Privacy Policy.",
  },
  MESSAGES: {
    OTP_SENT_SUCCESS: "OTP has been sent successfully.",
    OTP_VERIFICATION_FAILED: "Failed to verify OTP.",
    // Add more messages as needed
  },
  ERRORS: {
    CONSOLE: {
      API_CALL_FAILED: "Error during API call:",
    },
    MODAL: {
      GENERIC_ERROR: "An error occurred during submission.",
      OTP_REQUIRED: "OTP is required",
    },
  },
  VALIDATION: {
    NAME_REQUIRED: "Name must be at least 3 characters",
    EMAIL_INVALID: "Email is not valid",
    USERNAME_REQUIRED: "Username is required",
    PHONE_NUMBER_REQUIRED: "Phone number is required",
    COUNTRY_REQUIRED: "Please Select Country",
    STATE_REQUIRED: "Please Select State",
  },
});

export default TEXT_CONSTANTS;
